module.exports = __webpack_public_path__ + "officialStatic/img/vip-bg2.9468964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/vip-bg2.png
// module id = QdJS
// module chunks = 0